/**
 * LEVERI COULD NOT COMPLETE THE TECHNICAL EXECUTION AUTOMATICALLY (R6.3/R6.5).
 *
 * Shown only while the server says technical attention is open. Every word is
 * the server's: the sentence, and the number of attempts. It says nothing
 * about the accounting — no conclusion changed — and offers the one thing a
 * person can do: ask Leveri to try the same work again. The answer replaces
 * the file, like every other act on this screen.
 */
import { useState } from "react";
import { WorkActionResponse, type WorkFile } from "@leveri/contracts";
import { Button, Notice, Section } from "../../file/index.js";
import { call, failureMessage } from "../../api.js";

export function NeedsAttention({ work, onWork, onOutcome }: {
  work: WorkFile;
  onWork: (work: WorkFile) => void;
  onOutcome: (outcome: string) => void;
}) {
  const [busy, setBusy] = useState(false);
  const [failure, setFailure] = useState<string | null>(null);
  const attention = work.needsAttention;
  if (!attention) return null;

  async function retry() {
    if (busy) return;
    setBusy(true);
    setFailure(null);
    try {
      const result = await call("POST", `/api/work/${work.id}/retry`, WorkActionResponse);
      onOutcome(result.outcome);
      onWork(result.work);
    } catch (error) {
      setFailure(failureMessage(error));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Section>
      <Notice tone="attention">{attention.sentence}</Notice>
      <p className="mt-1.5 text-[13px] text-stone [font-variant-numeric:tabular-nums]">
        {attention.failedAttempts} attempts · since {attention.raisedAtText}
      </p>
      <div className="mt-3">
        <Button disabled={busy} onClick={() => void retry()}>Try again</Button>
      </div>
      {failure && <Notice className="mt-3">{failure}</Notice>}
    </Section>
  );
}
